function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "128",
  height: "128",
  viewBox: "0 0 33.87 33.87"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#d90947"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#ff585b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#0cc8ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#047afa"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#00ce4e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#a7e890"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "3.7",
  x2: "3.7",
  y1: "10.29",
  y2: "2.38",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: "23.73",
  x2: "23.73",
  y1: "9.34",
  y2: "2.38",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: "21.88",
  x2: "21.88",
  y1: "13.75",
  y2: "21.24",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: "3.7",
  x2: "3.7",
  y1: "13.29",
  y2: "20.86",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: "20.38",
  x2: "20.38",
  y1: "31.48",
  y2: "24.81",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: "2.38",
  x2: "2.38",
  y1: "31.28",
  y2: "23.88",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M8.23 5.97a3.59 3.59 0 01-3.58 3.58 3.59 3.59 0 01-3.6-3.58 3.59 3.59 0 013.6-3.59 3.59 3.59 0 013.58 3.59z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M12.74 2.38h18.75c.73 0 1.32.6 1.32 1.32v3.78c0 .74-.6 1.33-1.32 1.33H12.74c-.74 0-1.33-.6-1.33-1.33V3.7c0-.73.6-1.32 1.33-1.32z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M8.23 27.9a3.59 3.59 0 01-3.58 3.59 3.59 3.59 0 01-3.6-3.6 3.59 3.59 0 013.6-3.58 3.59 3.59 0 013.58 3.59z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M12.72 25.06h18.76c.73 0 1.32.6 1.32 1.32v3.78c0 .74-.6 1.33-1.32 1.33H12.72c-.73 0-1.32-.6-1.32-1.33v-3.78c0-.73.6-1.32 1.32-1.32z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M8.23 16.93a3.59 3.59 0 01-3.58 3.59 3.59 3.59 0 01-3.6-3.59 3.59 3.59 0 013.6-3.58 3.59 3.59 0 013.58 3.58z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  stroke: "rgba(0, 0, 0, 0.80)",
  d: "M12.72 14.1h18.76c.73 0 1.32.58 1.32 1.32v3.78c0 .73-.6 1.32-1.32 1.32H12.72c-.73 0-1.32-.59-1.32-1.32v-3.78c0-.74.6-1.33 1.32-1.33z",
  paintOrder: "markers fill stroke"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8c092f",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontVariantEastAsian: "normal",
    fontFeatureSettings: "normal",
    fontVariationSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    shapeMargin: "0",
    inlineSize: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  },
  d: "M11.94 29.66v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.33 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.33 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.33 0v.26h.52v-.26zm1.32 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.33 0v.26h.52v-.26zm1.32 0v.26h.53v-.26zm1.32 0v.26h.53v-.26zm1.32 0v.26H31v-.26zm1.27 0v.26h.53v-.26z",
  color: "#000",
  fontFamily: "sans-serif",
  fontWeight: "400",
  overflow: "visible",
  paintOrder: "markers fill stroke"
})));